import styled from "styled-components";
import React from "react";
import prognosLogo from "../../../assets/prognos_logotyp_rgb.png";

const LoginMainContainer = styled.div`
  position: absolute;
  top: 10%;
  background: white;
  border-radius: 5px;
  border: none;
  padding: 5px;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
  width: 100%;

  @media (min-width: 600px) {
    padding: 1em 0;
    top: 30%;
    min-height: 360px;
    left: calc(50% - 270px);
    width: 460px;

  }
`;

const ContentContainer = styled.div`
  padding: 16px;
`;
const LogoContainer = styled.div`
  text-align: center;
`;

const PrognosLogo = styled.img`
  height: 4em;
  padding: 6px;
`;

const LoginContainer = ({children, ...props}) => (
    <LoginMainContainer {...props}>
        <LogoContainer>
            <PrognosLogo src={prognosLogo}/>
        </LogoContainer>
        <ContentContainer>
            {children}
        </ContentContainer>
    </LoginMainContainer>
);

export default LoginContainer;